// Datos de la sociedad (escritura de constitución de 20/10/2026, protocolo 4.264).
// Cuando la sociedad esté inscrita, añadir los datos registrales en COMPANY.registro.
export const COMPANY = {
  razon: "HOLA TAANDEM, S.L.",
  marca: "TAANDEM",
  nif: "B05795653",
  domicilio: "Calle General Sanmartín, 11, 2º, 46004 Valencia (España)",
  email: "hola@somostaandem.com",
  web: "www.somostaandem.com",
  registro:
    "Sociedad constituida mediante escritura otorgada el 20 de octubre de 2026 ante el notario de Sabadell D. Alejandro Sáez Ripoll, con el número 4.264 de su protocolo, en trámite de inscripción en el Registro Mercantil de Valencia.",
};

const ACTUALIZADO = "26 de octubre de 2026";

const C = COMPANY;

export const LEGAL = {
  "aviso-legal": {
    label: "Legal",
    title: "Aviso legal",
    updated: ACTUALIZADO,
    sections: [
      {
        h: "Titular de la web",
        p: [
          `En cumplimiento del artículo 10 de la Ley 34/2002, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), te informamos de que esta web (${C.web}) es titularidad de:`,
        ],
        list: [
          `Denominación social: ${C.razon}`,
          `Nombre comercial: ${C.marca}`,
          `NIF: ${C.nif}`,
          `Domicilio: ${C.domicilio}`,
          `Correo electrónico: ${C.email}`,
          `Datos registrales: ${C.registro}`,
        ],
      },
      {
        h: "Condiciones de uso",
        p: [
          "El acceso a esta web es gratuito y atribuye la condición de usuario. Al navegar por ella aceptas este aviso legal. Te comprometes a hacer un uso adecuado de los contenidos y a no utilizarlos para actividades ilícitas o contrarias a la buena fe.",
        ],
      },
      {
        h: "Propiedad intelectual e industrial",
        p: [
          `Los textos, diseños, logotipos y demás elementos de esta web son propiedad de ${C.razon} o se utilizan con autorización de sus titulares. Queda prohibida su reproducción, distribución o transformación sin autorización expresa.`,
          "Las marcas, nombres comerciales e imágenes de terceros que aparecen en la sección de casos pertenecen a sus respectivos titulares y se muestran únicamente para ilustrar proyectos en los que hemos participado.",
        ],
      },
      {
        h: "Responsabilidad",
        p: [
          `${C.razon} trabaja para que la información de esta web sea correcta y esté actualizada, pero no garantiza la ausencia de errores ni la disponibilidad ininterrumpida del sitio, y no se hace responsable de los daños que pudieran derivarse de su uso.`,
          "Esta web puede contener enlaces a sitios de terceros, como redes sociales. No controlamos su contenido ni somos responsables de él.",
        ],
      },
      {
        h: "Legislación aplicable",
        p: [
          "Este aviso legal se rige por la legislación española. Para cualquier controversia, las partes se someten a los juzgados y tribunales que correspondan conforme a la normativa vigente.",
        ],
      },
    ],
  },

  privacidad: {
    label: "Legal",
    title: "Política de privacidad",
    updated: ACTUALIZADO,
    intro:
      "Te explicamos de forma clara qué datos tratamos, para qué y qué derechos tienes, de acuerdo con el Reglamento General de Protección de Datos (RGPD) y la Ley Orgánica 3/2018 (LOPDGDD).",
    sections: [
      {
        h: "Responsable del tratamiento",
        list: [
          `${C.razon} (NIF ${C.nif})`,
          C.domicilio,
          `Contacto: ${C.email}`,
        ],
      },
      {
        h: "Qué datos tratamos",
        p: [
          "Solo los que nos facilitas tú: nombre, correo electrónico, tipo de proyecto y el contenido de tu mensaje cuando usas el formulario de contacto o nos escribes por correo. No te pedimos datos especialmente protegidos; por favor, no los incluyas en tu mensaje.",
          "Además, el proveedor de alojamiento registra de forma técnica datos de conexión (como la dirección IP y el navegador) para servir la web y mantenerla segura.",
        ],
      },
      {
        h: "Para qué los usamos y con qué base legal",
        list: [
          "Responder a tu consulta y, si lo deseas, preparar una propuesta: aplicación de medidas precontractuales a petición tuya y consentimiento (art. 6.1.b y 6.1.a RGPD).",
          "Gestionar la relación profesional si llegamos a trabajar juntos: ejecución del contrato (art. 6.1.b RGPD).",
          "Mantener la seguridad y el buen funcionamiento de la web: interés legítimo (art. 6.1.f RGPD).",
        ],
        after: ["No elaboramos perfiles ni tomamos decisiones automatizadas, y no usamos tus datos para enviarte publicidad sin tu consentimiento."],
      },
      {
        h: "Cuánto tiempo los conservamos",
        p: [
          "Conservamos tus datos el tiempo necesario para atender tu consulta. Si no se inicia una relación profesional, los eliminamos en un plazo máximo de un año. Si trabajamos juntos, los conservamos mientras dure la relación y, después, durante los plazos que exija la ley.",
        ],
      },
      {
        h: "Con quién los compartimos",
        p: [
          "No cedemos tus datos a terceros, salvo obligación legal. Para prestar el servicio contamos con proveedores que tratan los datos por cuenta nuestra (encargados del tratamiento), con los que mantenemos los contratos exigidos por el RGPD:",
        ],
        list: [
          "Netlify, Inc.: alojamiento de la web.",
          "Web3Forms: envío de los mensajes del formulario de contacto a nuestro correo.",
          "Google (Google Workspace): gestión de nuestro correo electrónico.",
        ],
      },
      {
        h: "Transferencias internacionales",
        p: [
          "Algunos de estos proveedores pueden tratar datos fuera del Espacio Económico Europeo, principalmente en Estados Unidos. En esos casos, la transferencia se realiza con las garantías previstas en el RGPD, como las cláusulas contractuales tipo aprobadas por la Comisión Europea o la adhesión del proveedor al Marco de Privacidad de Datos UE-EE. UU.",
        ],
      },
      {
        h: "Tus derechos",
        p: [
          `Puedes ejercer en cualquier momento tus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento y portabilidad, así como retirar tu consentimiento, escribiendo a ${C.email}. Si lo necesitamos para verificar tu identidad, te pediremos información adicional.`,
          "Si consideras que no hemos tratado bien tus datos, puedes presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es).",
        ],
      },
      {
        h: "Menores de edad",
        p: ["Esta web no está dirigida a menores de 14 años y no tratamos conscientemente sus datos."],
      },
      {
        h: "Cambios en esta política",
        p: ["Podemos actualizar esta política para adaptarla a cambios legales o del servicio. La fecha de la última actualización aparece al principio de la página."],
      },
    ],
  },

  cookies: {
    label: "Legal",
    title: "Política de cookies",
    updated: ACTUALIZADO,
    intro:
      "Las cookies son pequeños archivos que algunas webs guardan en tu navegador. Te contamos cómo funciona esta.",
    sections: [
      {
        h: "Esta web no usa cookies",
        p: [
          "somostaandem.com no instala cookies propias ni de terceros: ni analíticas, ni publicitarias, ni de redes sociales. Tampoco guarda información en tu dispositivo por otros medios.",
          "Por eso no te mostramos ningún aviso de cookies: no hay nada que aceptar ni rechazar.",
        ],
      },
      {
        h: "Contenidos de terceros",
        p: [
          "Las fuentes tipográficas están alojadas en nuestro propio servidor, sin conexiones a servicios externos. Los enlaces a redes sociales (como Instagram) solo te llevan a esas plataformas cuando haces clic; una vez allí, se aplican sus propias políticas de cookies.",
        ],
      },
      {
        h: "Si esto cambia",
        p: [
          "Si en el futuro incorporamos cookies que no sean estrictamente necesarias, como las de analítica, actualizaremos esta política y te pediremos tu consentimiento antes de instalarlas.",
        ],
      },
      {
        h: "Contacto",
        p: [`Para cualquier duda sobre esta política, escríbenos a ${C.email}.`],
      },
    ],
  },
};
